import css from "styled-jsx/css";
import colors from "/styles/colors";

export const componentStyles = css`
  .footer-category-component {
    .title {
      margin-top: 8px;
      margin-bottom: 24px;
      font-size: 16px;
      font-weight: 700;
    }
  }
`;

export const linkStyles = css`
  .link {
    &:not(:last-child) {
      margin-bottom: 18px;
    }

    &:hover {
      color: ${colors["iris"]};
    }

    a {
      text-decoration: none;
      color: inherit;
      display: block;
    }
  }
`;
